/* eslint-disable no-use-before-define */
import React, { useEffect, useState, useRef } from "react";
import { useLocation, matchPath, useHistory } from "react-router-dom";
// import PerfectScrollbar from "react-perfect-scrollbar";
import ConfirmationDialog from "src/component/ConfirmationDialog";
import axios from "axios";
import ApiConfig from "src/ApiConfig/ApiConfig";
import { toast } from "react-hot-toast";
import { 
  FaUserAlt, 
  FaUsers, 
  FaStore, 
  FaImage, 
  FaCog, 
  FaFlag, 
  FaBell, 
  FaFileAlt, 
  FaQuestionCircle, 
  FaSignOutAlt,
  FaWallet,
  FaShieldAlt,
  FaListUl,
  FaUserCheck,
  FaFileSignature
} from "react-icons/fa";
import { MdReceipt, MdDescription, MdBrandingWatermark } from "react-icons/md";
import { RiExchangeDollarLine } from "react-icons/ri";
import PropTypes from "prop-types";
import {
  Box,
  Drawer,
  Hidden,
  List,
  Button,
  ListSubheader,
  makeStyles,
  Typography,
  Divider,
} from "@material-ui/core";

import NavItem from "./NavItem";

const sections = [
  {
    items: [
      {
        title: "Transaction Management",
        icon: RiExchangeDollarLine,
        href: "/transaction-management",
      },
      // {
      //   title: "Category Management",
      //   icon: "/images/dashboard/management.png",
      //   href: "/category-management",
      // },
      // {
      //   title: "Mood Management",
      //   icon: "/images/dashboard/vineyard.png",
      //   href: "/mood-management",
      // },
      {
        title: "User Management",
        icon: FaUsers,
        href: "/user-management",
      },
      {
        title: "Vendor Management",
        icon: FaStore,
        href: "/vendor-management",
      },
      {
        title: "Brand Management",
        icon: MdBrandingWatermark,
        href: "/brand-management",
      },
      {
        title: "NFT Management",
        icon: FaImage,
        href: "/nft-list",
      },
      
      {
        title: "Control",
        icon: FaCog,
        href: "/admin-control",
      },
      
      {
        title: "Report Management",
        icon: FaFlag,
        href: "/report-management",
      },
      {
        title: "Notified Management",
        icon: FaBell,
        href: "/notified-management",
      },
      {
        title: "Static Management",
        icon: FaFileAlt,
        href: "/static-management",
      },
      {
        title: "FAQ Management",
        icon: FaQuestionCircle,
        href: "/faq-list",
      },
      {
        title: "Compliance",
        icon: FaShieldAlt,
        href: "/compliance",
        items: [
          { title: "Overview", icon: FaShieldAlt, href: "/compliance" },
          { title: "Providers", icon: FaFileSignature, href: "/compliance/providers" },
          { title: "Policies", icon: FaListUl, href: "/compliance/policies" },
          { title: "Whitelist", icon: FaUserCheck, href: "/compliance/whitelist" },
          { title: "KYC Queue", icon: FaWallet, href: "/compliance/kyc-queue" },
          { title: "Audit Logs", icon: FaFileAlt, href: "/compliance/audit-logs" },
        ],
      },
      
      {
        title: "Logout",
        icon: FaSignOutAlt,
        href: "#",
        isLogout: true,
      },
    ],
  },
];


function renderNavItems({ items, pathname, depth = 0, onLogout }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth, onLogout }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth, onLogout }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
          onLogout,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
        isLogout={item.isLogout}
        onLogout={onLogout}
      />
    );
  }
  return acc;
}
const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
    background: "linear-gradient(180deg, #1D649C 0%, #155A8A 100%)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  desktopDrawer: {
    top: "76px",
    width: "250px",
    height: "calc(100vh - 100px)",
    margin: "5px 10px 10px 15px",
    borderRadius: "12px",
    border: "none",
    marginTop: "21px",
    marginLeft: "13px",
    background: "linear-gradient(180deg, #1D649C 0%, #155A8A 100%)",
    boxShadow: "0 4px 12px rgba(29, 100, 156, 0.3)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
  socialIcon: {
    cursor: "pointer",
    marginRight: 5,
  },
  button: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    height: "45px",
    paddingLeft: "17px",
    borderRadius: "12px",
    marginTop: "-30px",
    "&:hover": {
      color: "#F5C843",
    },
    "& svg": {
      color: "#F5C843",
      fontSize: "20px",
    },
  },
  mainSideTop:{
    height: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      height: "100%",
    },
    "& .mainSiderBarBox": {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "& .profileBox": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        borderRadius: "8px",
        margin: "16px",
        backdropFilter: "blur(10px)",
        "& .adminDp": {
          height: "100px",
          width: "100px",
          border: "4px solid rgba(255, 255, 255, 0.9)",
          borderRadius: "50%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          overflow: "hidden",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "scale(1.05)",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.25)",
          },
          "& img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "50%",
          },
          "&::after": {
            content: '"📷"',
            position: "absolute",
            bottom: "5px",
            right: "5px",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            color: "white",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            opacity: 0,
            transition: "opacity 0.3s ease",
          },
          "&:hover::after": {
            opacity: 1,
          },
        },
        "& h6": {
          color: "#fff",
          fontWeight: "600",
          margin: "12px 0px 8px 0px",
          fontSize: "16px",
          textAlign: "center",
        },
        "& p": {
          fontWeight: 400,
          color: "rgba(255, 255, 255, 0.8)",
          marginBottom: "0px",
          fontSize: "14px",
        },
      },
      "& .menuScroll": {
        flex: 1,
        overflow: "hidden",
        position: "relative",
      },
    },
  },
  btnBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "transparent",
    fontWeight: "400",
    fontSize: "13px",
    color: "#fff",
    marginTop: "20px",
    "& button": {
      borderRadius: "50px",
      position: "absolute",
      bottom: "10px",
    },
  },
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [profileImage, setProfileImage] = useState(() => {
    // Load image from localStorage on component mount
    const savedImage = localStorage.getItem('adminProfileImage');
    return savedImage || "/images/dashboard/profile.png";
  });
  const [adminName, setAdminName] = useState(() => {
    const savedName = localStorage.getItem('adminName');
    return savedName || 'Admin';
  });
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  // Fetch current admin profile on mount
  useEffect(() => {
    let isActive = true;
    (async () => {
      try {
        const token = window.localStorage.getItem("token");
        if (!token) return;
        const res = await axios({
          method: "GET",
          url: ApiConfig.getProfile,
          headers: { token },
        });
        if (!isActive) return;
        if (res.data?.responseCode === 200) {
          const result = res.data?.result || {};
          const name = result.name || result.userName || result.fullName || result.username || 'Admin';
          const img = result.profilePic || result.image || result.avatar || null;
          setAdminName(name || 'Admin');
          localStorage.setItem('adminName', name || 'Admin');
          if (img && img !== profileImage) {
            setProfileImage(img);
          }
        }
      } catch (e) {
        // silent fail; fall back to defaults/localStorage
      }
    })();
    return () => { isActive = false; };
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file type
      if (!file.type.startsWith('image/')) {
        toast.error('Please select a valid image file');
        return;
      }
      
      // Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error('Image size should be less than 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const imageData = e.target.result;
        setProfileImage(imageData);
        // Save to localStorage for persistence
        localStorage.setItem('adminProfileImage', imageData);
        toast.success('Profile image updated successfully');
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleRemoveImage = () => {
    setProfileImage("/images/dashboard/profile.png");
    localStorage.removeItem('adminProfileImage');
    toast.success('Profile image removed successfully');
  };

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box className={classes.mainSideTop}>
        <Box className="mainSiderBarBox">
          <Box className="profileBox">
            <Box className="adminDp" onClick={handleImageClick} style={{ cursor: 'pointer' }}>
              <img src={profileImage} alt="Admin Profile" style={{ filter: 'brightness(0) invert(1)' }} />
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleImageUpload}
                accept="image/*"
                style={{ display: 'none' }}
              />
            </Box>
            <Typography variant="h6">{adminName || 'Admin'}</Typography>
          </Box>
          <Box className="menuScroll">
            <Box 
              pt={2} 
              pb={2} 
              style={{ 
                margin: "10px", 
                height: "calc(100vh - 250px)", 
                maxHeight: "500px", 
                minHeight: "300px", 
                overflowY: "auto", 
                overflowX: "hidden",
                scrollbarWidth: "none", /* Firefox */
                msOverflowStyle: "none", /* IE and Edge */
              }}
              sx={{
                "&::-webkit-scrollbar": {
                  display: "none" /* Chrome, Safari, Opera */
                }
              }}
            >
              {sections.map((section, i) => (
                <List
                  key={`menu${i}`}
                  subheader={
                    <ListSubheader disableGutters disableSticky>
                      {section.subheader}
                    </ListSubheader>
                  }
                >
                  {renderNavItems({
                    items: section.items,
                    pathname: location.pathname,
                    onLogout: () => setOpen(true),
                  })}
                </List>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      <ConfirmationDialog
        open={open}
        handleClose={() => setOpen(false)}
        title={"Logout"}
        desc={"Do you want to Logout ?"}
      />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          <Box p={2}>{content}</Box>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
